import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

export { default as filesStyles } from "src/app/styles/screens/files.style";

const cloudieStyles = {
  page: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
    overflowY: "auto",
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1.5,
    mb: 2,
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 26,
    fontWeight: 700,
    letterSpacing: "-0.5px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
  },

  storagePill: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 1.5,
    py: 0.75,
    borderRadius: 99,
    border: "1px solid rgba(0, 0, 0, 0.1)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
  },
  storagePillTrack: {
    width: 80,
    height: 5,
    borderRadius: 99,
    backgroundColor: "rgba(0,0,0,0.1)",
    overflow: "hidden",
  },

  breadcrumbRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    flexWrap: "wrap",
    mb: 2.5,
  },
  breadcrumbItem: {
    cursor: "pointer",
    color: colorsConstants.primaryText,
    opacity: 0.55,
    fontSize: 13,
    fontWeight: 500,
    "&:hover": { opacity: 1, textDecoration: "underline" },
  },
  breadcrumbActive: {
    cursor: "default",
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 13,
    opacity: 1,
  },

  selectorContainer: { width: "100%", mb: 2 },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    maxWidth: 300,
    ml: "auto",
  },

  adminChip: { mb: 2 },

  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    py: 10,
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    py: 10,
    gap: 1.5,
    opacity: 0.5,
  },
  emptyIcon: { fontSize: 64, opacity: 0.3 },
  emptyText: {
    color: colorsConstants.primaryText,
    fontSize: 15,
    fontWeight: 500,
  },

  folderSection: { mb: 3 },
  folderSectionLabel: {
    color: colorsConstants.primaryText,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    opacity: 0.45,
    mb: 1.5,
  },
  folderCard: {
    p: 2,
    borderRadius: 2.5,
    border: "1px solid rgba(0, 0, 0, 0.07)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    cursor: "pointer",
    transition: "box-shadow 0.15s, transform 0.12s",
    "&:hover": {
      boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
      transform: "translateY(-2px)",
    },
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    position: "relative",
  },
  folderIconWrap: {
    width: 44,
    height: 44,
    borderRadius: 1.5,
    backgroundColor: "rgba(249,168,37,0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  folderName: {
    color: colorsConstants.primaryText,
    fontWeight: 600,
    fontSize: 13,
    wordBreak: "break-word",
    flex: 1,
    lineHeight: 1.3,
  },
  folderActions: {
    display: "flex",
    gap: 0.25,
    opacity: 0,
    transition: "opacity 0.15s",
    ".folderCard:hover &": { opacity: 1 },
  },

  mediaSection: {},
  mediaSectionLabel: {
    color: colorsConstants.primaryText,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    opacity: 0.45,
    mb: 1.5,
  },

  mediaCard: {
    position: "relative",
    borderRadius: 2,
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: "rgba(0,0,0,0.06)",
    "&:hover .mediaOverlay": { opacity: 1 },
    "&:hover .mediaCardImg": { transform: "scale(1.04)" },
    boxShadow: "none",
    transition: "box-shadow 0.15s",
    "&:hover": { boxShadow: "0 6px 24px rgba(0,0,0,0.18)" },
  },
  mediaAspectBox: {
    width: "100%",
    paddingTop: "100%",
    position: "relative",
    overflow: "hidden",
  },
  mediaImg: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  mediaOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.0) 55%)",
    opacity: 0,
    transition: "opacity 0.2s",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    p: 1,
  },
  mediaOverlayName: {
    color: "#fff",
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1.3,
    mb: 0.5,
    wordBreak: "break-word",
  },
  mediaOverlayActions: {
    display: "flex",
    gap: 0.25,
    flexWrap: "wrap",
  },
  mediaOverlayIconBtn: {
    color: "rgba(255,255,255,0.9)",
    p: 0.5,
    "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
  },
  videoPlayBadge: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "rgba(255,255,255,0.88)",
    fontSize: 44,
    pointerEvents: "none",
    filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.6))",
    transition: "opacity 0.2s",
  },
  sharedBadge: {
    position: "absolute",
    top: 6,
    right: 6,
    backgroundColor: "rgba(0,0,0,0.45)",
    borderRadius: "50%",
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  uploadPanel: {
    position: "fixed",
    bottom: 24,
    right: 24,
    width: 300,
    zIndex: 1300,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  uploadCard: {
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  },

  lightboxBackdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.96)",
    zIndex: 1400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  lightboxTopBar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 2,
    py: 1.5,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.75) 0%, transparent 100%)",
    zIndex: 2,
  },
  lightboxFileName: {
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    opacity: 0.9,
    maxWidth: "60vw",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  lightboxTopActions: {
    display: "flex",
    gap: 0.5,
  },
  lightboxIconBtn: {
    color: "rgba(255,255,255,0.85)",
    "&:hover": { color: "#fff", backgroundColor: "rgba(255,255,255,0.1)" },
  },
  lightboxNavBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "rgba(255,255,255,0.75)",
    backgroundColor: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.15)",
    backdropFilter: "blur(4px)",
    "&:hover": {
      color: "#fff",
      backgroundColor: "rgba(255,255,255,0.18)",
    },
    zIndex: 2,
  },
  lightboxPrevBtn: { left: { xs: 8, sm: 20 } },
  lightboxNextBtn: { right: { xs: 8, sm: 20 } },
  lightboxImg: {
    maxWidth: { xs: "90vw", sm: "80vw" },
    maxHeight: "85vh",
    objectFit: "contain",
    borderRadius: 1,
    userSelect: "none",
    display: "block",
  },
  lightboxVideo: {
    maxWidth: { xs: "90vw", sm: "80vw" },
    maxHeight: "85vh",
    borderRadius: 1,
    outline: "none",
    display: "block",
  },
  lightboxCounter: {
    position: "absolute",
    bottom: 16,
    left: "50%",
    transform: "translateX(-50%)",
    color: "rgba(255,255,255,0.5)",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.5,
    zIndex: 2,
  },
  modalActionsContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    mb: 1.5,
  },
  modalCancelButton: { color: colorsConstants.error },
  accessListItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: 0.5,
    px: 1,
    borderRadius: 1,
    mb: 0.5,
    border: "1px solid rgba(0,0,0,0.06)",
    backgroundColor: "rgba(0,0,0,0.02)",
  },
} satisfies Record<string, SxProps<Theme>>;

export default cloudieStyles;
